var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m63.156 28.5l-3 2.8516c-0.78906 0.74609-0.78906 2.168 0 2.9141l12.289 11.715h-58.133c-0.98438 0.09375-1.8164 1.0156-1.8125 2.0039v4.0078c0 1.0508 0.95312 2.0039 2 2.0039h57.945c-4.1602 3.9609-8.1875 7.8086-12.289 11.715-0.78906 0.74609-0.78906 2.168 0 2.9141l3 2.8516c0.73438 0.69531 2.0156 0.69531 2.75 0 6.0117-5.7305 15.004-14.32 21.012-20.047 0.76953-0.74609 0.76953-2.1367 0-2.8828l-21.012-20.047c-1.0195-0.78906-1.8164-0.53516-2.75 0z"}));
}

Arrow.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Arrow;

Arrow.default = Arrow;
